(function () {
    'use strict';

    angular.module('swif.reservations')
    .controller('RequestEventsEditModal', RequestEventsEditModal);

    function RequestEventsEditModal ($scope, $q, swif, openresa, openbase) {
        'ngInject';
        $scope.onChangeReferent = onChangeReferent;
        $scope.setActiveBooking = setActiveBooking;
        $scope.displayResources = displayResources;
        $scope.addPrestation = addPrestation;
        $scope.removePrestation = removePrestation;
        $scope.addKey = addKey;
        $scope.removeKey = removeKey;
        $scope.addAttendee = addAttendee;
        $scope.removeAttendee = removeAttendee;
        $scope.onChangeFakeKey = onChangeFakeKey;
        $scope.initialize = initialize;
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;

        $scope.initialize();

        // for example: {referent_people: ''}, {referent_people: 'bla'} => {'referent_people': 'bla'}
        function swifDefaults (target, src) {
            _.forOwn(src, function (val, key) {
                // merge all True evaluable value
                // when target value is False evaluable (not only !== undefined)
                if (val && !target[key]) {
                    target[key] = val;
                }
            });
        }

        function setActiveBooking (booking) {
            if (!$scope.model._selectedBooking || $scope.model._selectedBooking !== booking) {
                // prepare booking structure and set it as 'selected'
                openresa.bookings.init(booking);
                $scope.model._selectedBooking = booking;
                // ensure ALL its data are fetched
                var defer = $q.when(true);
                if (booking.id && !booking.fetched) {
                    var options = {attendees: true, keys: true, prestations: true};
                    defer = openresa.bookings.fetch(booking, options);
                }
                // 2nd step: default values for modal purposes
                defer.then(function () {
                    var defaultValues = {
                        is_event: $scope.anchor.event,
                        checkin_state: 'scheduled',
                        checkout_state: 'scheduled',
                        checkin_date: booking.checkin,
                        checkout_date: booking.checkout,
                        key_checkin_state: 'scheduled',
                        key_checkout_state: 'scheduled',
                        key_checkin_date: booking.checkin,
                        key_checkout_date: booking.checkout
                    };
                    // pre-fill referent_people with claimer contact
                    var contact = $scope.model.partner_invoice_id;
                    var contactName = contact ? contact[1] : $scope.model.people_name;
                    if (!booking.referent_people && contactName && !$scope.feature_referent_required) {
                        defaultValues.referent_people = contactName;
                    }
                    // then, apply default values to model and lines
                    swifDefaults(booking, defaultValues);
                    _.forEach(booking.lines, function (line) {
                        var defaultLine = {
                            checkin_bookable_state: line.resource.patrimoine_state,
                            checkout_bookable_state: line.resource.patrimoine_state
                        };
                        swifDefaults(line, defaultLine);
                    });
                    // finally, prepare prestation models
                    _.forEach(booking.prestations, function (prestation) {
                        preparePrestationAndFilter(prestation);
                    });
                });
            }
        }

        function displayResources (lines) {
            var ret = [];
            _.forEach(lines, function (line) {
                ret.push(line.resource.name);
            });
            return ret.join(', ');
        }

        function addPrestation (prestationSelected) {
            var prestation = {
                _type: 'reservationPrestation',
                prestation_id: prestationSelected,
                prestation_state: 'waiting',
                state: 'prestation_waiting',
                actions: ['update', 'submit', 'delete']
            };
            preparePrestationAndFilter(prestation);
            $scope.model._selectedBooking.prestations.push(prestation);
        }

        function preparePrestationAndFilter (prestation) {
            prestation.filters = {department: {}};
            // compute service_id filter, pre-fill service_id, pre-fill price
            if (prestation.prestation_id) {
                var f = {fields: ['name', 'service_ids', 'service_names', 'list_price']};
                swif.data.get('prestation', prestation.prestation_id[0], f)
                .then(function (data) {
                    if (!_.isEmpty(data.service_ids)) {
                        swif.data.addFilter(prestation.filters.department, 'id', 'in', data.service_ids);
                        if (!_.isEmpty(data.service_names) && !prestation.service_id) {
                            prestation.service_id = data.service_names[0];
                        }
                    } else if ($scope.modules.openstc) {
                        swif.data.addFilter(prestation.filters.department, 'is_assignable_to_ask', '=', true);
                    }
                    if (!prestation.id && !prestation.price) {
                        prestation.price = data.list_price;
                    }
                    prestation.expected_date = prestation.expected_date || $scope.model._selectedBooking.checkin;
                });
            }
            prestation._actions = {
                update: !prestation.id || prestation.actions.indexOf('update') > -1,
                delete: !prestation.id || prestation.actions.indexOf('delete') > -1,
                submit: !prestation.id || prestation.actions.indexOf('submit') > -1
            };
        }

        function removePrestation (prestation) {
            // _.remove($scope.model._selectedBooking.prestations, {id: prestation.id});
            _.remove($scope.model._selectedBooking.prestations, prestation);
        }

        function addKey (key) {
            var active = $scope.model._selectedBooking;
            var found = _.find(active.keys, function (elt) {
                return elt.key ? elt.key.id === key.id: false;
            });
            if (!found) {
                var value = {
                    name: key.name,
                    key_id: [key.id, key.name],
                    key: key,
                    checkin_bookable_state: key.state,
                    checkout_bookable_state: key.state
                };
                $scope.model._selectedBooking.keys.push(value);
            }
        }

        function removeKey (key) {
            var active = $scope.model._selectedBooking;
            return _.remove(active.keys, key);
        }

        $scope.userCache = {};

        function addAttendee (people, isEmail) {
            var attendeeId, attendeeName;
            if (isEmail) {
                attendeeName = people;
            } else {
                attendeeId = people[0];
                attendeeName = people[1];
            }
            var user;
            var existingitem = _.find($scope.model._selectedBooking.attendees, function (elt) {
                if (isEmail) {
                    return elt.email === attendeeName;
                } else {
                    return elt.user ? elt.user.id === attendeeId : false;
                }
            });
            if (!existingitem) {
                var value = {name: attendeeName, user: {}, state: 'needsAction'};
                if (isEmail) {
                    value.email = attendeeName;
                    $scope.model._selectedBooking.attendees.push(value);
                } else {
                    user = $scope.userCache[attendeeId];
                    var defer = true;
                    if (!user && attendeeId) {
                        user = {};
                        // if user must be fetch from server, save it into cache
                        defer = swif.data.get('user', attendeeId, {fields: ['name', 'email']})
                        .then(function (data) {
                            $scope.userCache[data.id] = data;
                            _.merge(user, data);
                        });
                    }
                    // then, if user was fetch (or found in cache), complete attendee
                    // and add it to the existing attendees
                    $q.when(defer).then(function() {
                        value.user = user;
                        value.email = user.email;
                        $scope.model._selectedBooking.attendees.push(value);
                    });
                }
            }
        }

        function removeAttendee (attendee) {
            _.remove($scope.model._selectedBooking.attendees, {id: attendee.id});
        }

        function prepareEvent (booking) {
            var defaultValues = {};
            // defaultValues.attendees = [];  done on service.requests.initializeAttendees
            defaultValues.event_date_start = booking.checkin;
            defaultValues.event_date_end = booking.checkout;
            _.forEach(defaultValues, function (val, key) {
                if (!booking[key]) {
                    booking[key] = val;
                }
            });
        }

        function initialize () {
            $scope.currentPage = 1;
            $scope.modules = swif.module.modules;
            $scope.feature_referent_required = swif.settings.app.features.resa_referent_required;
            openresa.rights.getUserAbility($scope);
            $scope.filters = {
                prestation: {},
                key: {fields: ['name', 'state']},
                referent: {fields: ['name', 'complete_name', 'phone', 'mobile']}
            };
            swif.data.addFilter($scope.filters.prestation, 'sale_ok', '=', true);
            swif.data.addFilter($scope.filters.key, 'categ_id.is_key', '=', true);
            swif.data.addFilter($scope.filters.referent, 'partner_id.supplier', '=', false);
            var a = $scope.model._anchor;
            $scope.anchor = {
                event: !a || a === 'event',
                inter: a === 'intervention',
                check: a === 'check',
                key: a === 'key'
            };
            // $q.when($scope.model._deferred, function () {
            var bFilter = {fields: ['event_date_start', 'event_date_end']};
            swif.data.sortOn(bFilter, 'checkin', 'ASC');
            openresa.requests.fetch($scope.model, bFilter).then(function () {
                // once model is fully initialized, retrieve active bookings
                openresa.requests.linkRecurrenteBookings($scope.model);
                openresa.requests.fetchSlowFields($scope.model);
                $scope.activeBookings = [];
                $scope.model._selectedBooking = {};
                _.forEach($scope.model.bookings, function (booking) {
                    if (booking.state !== 'inactive') {
                        prepareEvent(booking);
                        $scope.activeBookings.push(booking);
                    }
                });
                // set the active booking to the 1st active booking found
                if (!$scope.model._selectedBooking.id) {
                    // activate:
                    // - a specific booking (if found) if _specificObjId is attached bo model
                    // - otherwise, the first booking found (priority to event bookings)
                    var specific;
                    var first = _.find($scope.activeBookings, {is_event: true}) || $scope.activeBookings[0];
                    if ($scope.model._specificObjId) {
                        specific = _.find($scope.activeBookings, {id: $scope.model._specificObjId});
                        var index = $scope.activeBookings.indexOf(specific);
                        $scope.currentPage = Math.floor(index / 10) + 1;
                    }
                    var booking = specific || first;
                    if (booking) {
                        $scope.setActiveBooking(booking);
                    }
                }
            });
        }

        function onChangeReferent (address) {
            if (address.id) {
                $scope.model._selectedBooking.referent_people = address.name || '';
                var phone = address.phone || address.mobile || '';
                $scope.model._selectedBooking.referent_people_phone = phone;
            }
        }

        function onChangeFakeKey (key) {
            if (key.id) {
                $scope.addKey(key);
                $scope.model._selectedBooking.fakeKey = false;
            }
        }

        $scope.$watch('model._selectedBooking.fakePrestation', function (newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                $scope.addPrestation(newV);
                $scope.model._selectedBooking.fakePrestation = false;
            }
        });

        $scope.$watch('model._selectedBooking.fakeAttendee', function (newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                $scope.addAttendee(newV);
                $scope.model._selectedBooking.fakeAttendee = false;
            }
        });

        var dateSync = [
            ['checkin_date', 'checkin_done_date'],
            ['checkout_date', 'checkout_done_date'],
            ['key_checkin_date', 'key_checkin_done_date'],
            ['key_checkout_date', 'key_checkout_done_date']
        ];
        $scope.$watchGroup(_.map(dateSync, function (elt) {
            return 'model._selectedBooking.' + elt[0];
        }), function (newV, oldV) {
            var model = $scope.model._selectedBooking;
            for (var i = 0; i < newV.length; i++) {
                if (newV[i] !== oldV[i]) {
                    var dt2 = model[dateSync[i][1]];
                    if (!dt2 || dt2 === oldV[i]) {
                        model[dateSync[i][1]] = newV[i];
                    }
                }
            }
        });
    }
})();
